import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';


@Injectable({
  providedIn: 'root'
})
export class BrokerDropdownService {

  constructor(private http: HttpClient) { }

  getCorporateBrokers(): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.CORPORATE_BROKERS)
      .pipe(
        catchError(errorHandl)
      );
  }

  
}
